// File: frontend/src/routes/routes.js

export const ROUTES = {
  // Public Routes
  HOME: '/',
  ABOUT: '/about',
  CONTACT: '/contact',
  PRICING: '/pricing',
  PRODUCTS_OVERVIEW: '/products',
  PRODUCTS: '/products/:productSlug',
  PRIVACY: '/privacy-policy',
  TERMS: '/terms-of-service',
  SMS_TERMS: '/sms-terms',
  VERIFY_EMAIL: '/auth/verify-email',
  
  // Newsletter Routes
  NEWSLETTER_UNSUBSCRIBE: '/newsletter/unsubscribe',
  NEWSLETTER_RESUBSCRIBE: '/newsletter/resubscribe',
  NEWSLETTER_PREFERENCES: '/newsletter/preferences',
  
  // Dashboard Routes (Private)
  DASHBOARD: '/dashboard',
  ACCOUNT: '/account',
  POLICIES: '/dashboard/policies',
  POLICY_DETAILS: '/dashboard/policy-details/:fileId',
  UPLOAD: '/dashboard/upload',
  CLAIMS: '/dashboard/claims',
  CHATS: '/dashboard/chats',
  CHAT_DETAIL: '/dashboard/chat/:chatId',
  POLICY_ANALYTICS: '/dashboard/policy-analytics',
  
  // Admin Routes (Role-based)
  UMS: '/dashboard/ums',
  QMS: '/dashboard/qms',
  EMS: '/dashboard/ems',
  TMS: '/dashboard/tms',
  UPS: '/dashboard/ups',
  AI: '/dashboard/ai',
  DMS: '/dashboard/dms',
};

export default ROUTES;